module.exports = __webpack_public_path__ + "static/media/imgMarketing.a976526b.svg";